import React from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Notification.css";

/**
 * Universal toast notification trigger configured to auto close after 2 seconds (2000ms).
 */
export const showToast = (message, options = {}) => {
  if (!message) return;
  const opts = typeof options === "string" ? { type: options } : { ...options };
  const type = (opts.type || "default").toLowerCase();

  const toastConfig = {
    autoClose: 2000,
    closeOnClick: true,
    closeButton: true,
    transition: Slide,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    hideProgressBar: false,
    ...opts,
    autoClose: opts.autoClose !== undefined ? opts.autoClose : 2000,
  };

  if (type === "success" && toast.success) {
    return toast.success(message, toastConfig);
  } else if (type === "error" && toast.error) {
    return toast.error(message, toastConfig);
  } else if (type === "warning" && toast.warning) {
    return toast.warning(message, toastConfig);
  } else if (type === "info" && toast.info) {
    return toast.info(message, toastConfig);
  } else {
    return toast(message, toastConfig);
  }
};

/**
 * The single app-wide toast container. Mount it once at the root (see index.js).
 * Several containers sharing the default containerId make react-toastify look a
 * toast up in the wrong container during render and crash on route changes.
 */
export const NotificationHost = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={2000}
      transition={Slide}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick={true}
      closeButton={true}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={true}
      pauseOnHover={true}
      limit={5}
      className="ahd-toast-container"
      toastClassName="ahd-toast"
      bodyClassName="ahd-toast-body"
      progressClassName="ahd-toast-progress"
    />
  );
};

/**
 * Kept so existing pages can keep rendering <Notification />; the toasts are
 * rendered by the single NotificationHost instead.
 */
export const Notification = () => null;

export default Notification;
